import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './data-protection-privacy.css'

const DataProtectionPrivacy = (props) => {
  return (
    <div className="data-protection-privacy-container1">
      <Helmet>
        <title>Cysigil Network Pvt Ltd</title>
        <meta
          property="og:title"
          content="Data-Protection-Privacy - Well Off Notable Fish"
        />
        <link
          rel="canonical"
          href="https://well-off-notable-fish-gmgkwg.teleporthq.app/data-protection-privacy"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="hero-data-protection">
        <video
          src="https://videos.pexels.com/video-files/6962334/6962334-hd_1280_720_25fps.mp4"
          loop="true"
          muted="true"
          autoPlay="true"
          playsInline="true"
          className="hero-data-protection__video"
        ></video>
        <div className="hero-data-protection__overlay"></div>
        <div className="hero-data-protection__content">
          <div className="hero-data-protection__text">
            <h1 className="hero-title hero-data-protection__title">
              Data Protection &amp; Privacy Excellence
            </h1>
            <p className="hero-data-protection__subtitle hero-subtitle">
              Design comprehensive privacy programs, conduct thorough impact
              assessments, and implement robust controls that protect sensitive
              data while maintaining compliance with global regulations.
            </p>
            <div className="hero-data-protection__cta-group">
              <a href="#contact">
                <div className="btn-primary btn btn-lg">
                  <span>Request Privacy Assessment</span>
                </div>
              </a>
              <a href="#process">
                <div className="btn btn-lg btn-outline">
                  <span style={{ color: 'black' }}>Explore Our Process</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <section className="features-overview">
        <div className="features-overview__container">
          <div className="features-overview__header">
            <h2 className="section-title features-overview__title">
              Comprehensive Data Protection Program Design
            </h2>
            <p className="section-content features-overview__description">
              Build a resilient data protection framework aligned with GDPR,
              CCPA, ISO 27701, and emerging privacy regulations through
              systematic program design and continuous improvement.
            </p>
          </div>
          <div className="features-overview__grid">
            <div className="features-overview__card">
              <div className="features-overview__icon-wrapper">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="features-overview__card-title">
                Privacy Program Architecture
              </h3>
              <p className="features-overview__card-text">
                Design end-to-end privacy governance frameworks with clear
                roles, responsibilities, policies, and procedures that scale
                with your organization&apos;s growth and regulatory
                requirements.
              </p>
            </div>
            <div className="features-overview__card">
              <div className="features-overview__icon-wrapper">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="features-overview__card-title">
                Privacy Impact Assessments
              </h3>
              <p className="features-overview__card-text">
                Conduct systematic PIAs to identify, evaluate, and mitigate
                privacy risks in new projects, systems, and data processing
                activities before implementation.
              </p>
            </div>
            <div className="features-overview__card">
              <div className="features-overview__icon-wrapper">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
                    <path d="M3 5v14a9 3 0 0 0 18 0V5"></path>
                    <path d="M3 12a9 3 0 0 0 18 0"></path>
                  </g>
                </svg>
              </div>
              <h3 className="features-overview__card-title">
                Data Classification &amp; Mapping
              </h3>
              <p className="features-overview__card-text">
                Establish comprehensive data inventories, classification
                taxonomies, and flow mapping to understand what data you hold,
                where it resides, and how it moves across systems.
              </p>
            </div>
            <div className="features-overview__card">
              <div className="features-overview__icon-wrapper">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
                    <path d="m19 9l-5 5l-4-4l-3 3"></path>
                  </g>
                </svg>
              </div>
              <h3 className="features-overview__card-title">
                Privacy Control Framework
              </h3>
              <p className="features-overview__card-text">
                Implement technical and organizational controls covering data
                minimization, purpose limitation, access controls, encryption,
                and retention policies aligned with privacy principles.
              </p>
            </div>
            <div className="features-overview__card">
              <div className="features-overview__icon-wrapper">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                      <path d="M6.376 18.91a6 6 0 0 1 11.249.003"></path>
                      <circle r="4" cx="12" cy="11"></circle>
                    </g>
                  </g>
                </svg>
              </div>
              <h3 className="features-overview__card-title">
                Consent &amp; Rights Management
              </h3>
              <p className="features-overview__card-text">
                Design consent mechanisms and data subject rights processes that
                ensure transparency, user control, and rapid response to access,
                rectification, and erasure requests.
              </p>
            </div>
            <div className="features-overview__card">
              <div className="features-overview__icon-wrapper">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="16" y="16" rx="1" width="6" height="6"></rect>
                    <rect x="2" y="16" rx="1" width="6" height="6"></rect>
                    <rect x="9" y="2" rx="1" width="6" height="6"></rect>
                    <path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3m-7-4V8"></path>
                  </g>
                </svg>
              </div>
              <h3 className="features-overview__card-title">
                Vendor Privacy Oversight
              </h3>
              <p className="features-overview__card-text">
                Establish third-party data processing governance with vendor
                assessments, data processing agreements, and ongoing monitoring
                to maintain accountability throughout the data supply chain.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="timeline-process">
        <div className="timeline-process__wrapper">
          <div className="timeline-process__header">
            <h2 className="timeline-process__title section-title">
              Privacy Impact Assessment Methodology
            </h2>
            <p className="section-content timeline-process__description">
              Our structured PIA framework identifies privacy risks early,
              evaluates severity and likelihood, and delivers actionable
              mitigation strategies to ensure privacy-by-design.
            </p>
          </div>
          <div className="timeline-process__container">
            <div className="timeline-process__line"></div>
            <div className="timeline-process__item">
              <div className="timeline-process__marker">
                <span className="timeline-process__number">01</span>
              </div>
              <div className="timeline-process__content">
                <h3 className="timeline-process__item-title">
                  Scoping &amp; Data Flow Analysis
                </h3>
                <p className="timeline-process__item-text">
                  Define assessment boundaries, identify data types, processing
                  purposes, and map complete data flows across systems, third
                  parties, and jurisdictions.
                </p>
              </div>
            </div>
            <div className="timeline-process__item">
              <div className="timeline-process__marker">
                <span className="timeline-process__number">02</span>
              </div>
              <div className="timeline-process__content">
                <h3 className="timeline-process__item-title">
                  Privacy Risk Identification
                </h3>
                <p className="timeline-process__item-text">
                  Systematically identify privacy threats including unauthorized
                  access, excessive collection, inadequate consent, and
                  non-compliance with data protection principles.
                </p>
              </div>
            </div>
            <div className="timeline-process__item">
              <div className="timeline-process__marker">
                <span className="timeline-process__number">03</span>
              </div>
              <div className="timeline-process__content">
                <h3 className="timeline-process__item-title">
                  Risk Scoring &amp; Prioritization
                </h3>
                <p className="timeline-process__item-text">
                  Apply risk matrices to evaluate likelihood and impact,
                  categorize risks by severity, and prioritize remediation
                  efforts based on regulatory and business context.
                </p>
              </div>
            </div>
            <div className="timeline-process__item">
              <div className="timeline-process__marker">
                <span className="timeline-process__number">04</span>
              </div>
              <div className="timeline-process__content">
                <h3 className="timeline-process__item-title">
                  Mitigation Strategy Design
                </h3>
                <p className="timeline-process__item-text">
                  Develop comprehensive remediation plans with technical
                  controls, policy updates, training requirements, and
                  governance enhancements to reduce residual risk.
                </p>
              </div>
            </div>
            <div className="timeline-process__item">
              <div className="timeline-process__marker">
                <span className="timeline-process__number">05</span>
              </div>
              <div className="timeline-process__content">
                <h3 className="timeline-process__item-title">
                  Stakeholder Consultation
                </h3>
                <p className="timeline-process__item-text">
                  Engage data protection officers, legal teams, IT security, and
                  business units to validate findings, refine recommendations,
                  and ensure cross-functional alignment.
                </p>
              </div>
            </div>
            <div className="timeline-process__item">
              <div className="timeline-process__marker">
                <span className="timeline-process__number">06</span>
              </div>
              <div className="timeline-process__content">
                <h3 className="timeline-process__item-title">
                  Remediation Roadmap Delivery
                </h3>
                <p className="timeline-process__item-text">
                  Provide detailed implementation roadmaps with timelines,
                  resource requirements, success metrics, and monitoring
                  procedures for ongoing privacy assurance.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="process-lifecycle">
        <div className="process-lifecycle__container">
          <div className="process-lifecycle__header">
            <h2 className="process-lifecycle__title section-title">
              Data Lifecycle Governance
            </h2>
            <p className="section-content process-lifecycle__description">
              Comprehensive controls from collection to disposal ensuring data
              protection at every stage.
            </p>
          </div>
          <div className="process-lifecycle__steps">
            <div className="process-lifecycle__step">
              <div className="process-lifecycle__step-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
                    <path d="M3 5v14a9 3 0 0 0 18 0V5"></path>
                    <path d="M3 12a9 3 0 0 0 18 0"></path>
                  </g>
                </svg>
              </div>
              <div className="process-lifecycle__step-content">
                <h3 className="process-lifecycle__step-title">
                  Collection &amp; Creation
                </h3>
                <p className="process-lifecycle__step-text">
                  Data minimization, lawful basis documentation, consent
                  mechanisms, and purpose specification at point of collection.
                </p>
              </div>
            </div>
            <div className="process-lifecycle__arrow">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  d="M5 12h14m-6 6l6-6m-6-6l6 6"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </div>
            <div className="process-lifecycle__step">
              <div className="process-lifecycle__step-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                      <path d="M6.376 18.91a6 6 0 0 1 11.249.003"></path>
                      <circle r="4" cx="12" cy="11"></circle>
                    </g>
                  </g>
                </svg>
              </div>
              <div className="process-lifecycle__step-content">
                <h3 className="process-lifecycle__step-title">
                  Storage &amp; Processing
                </h3>
                <p className="process-lifecycle__step-text">
                  Encryption at rest and in transit, access controls, role-based
                  permissions, audit logging, and secure processing
                  environments.
                </p>
              </div>
            </div>
            <div className="process-lifecycle__arrow">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  d="M5 12h14m-6 6l6-6m-6-6l6 6"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </div>
            <div className="process-lifecycle__step">
              <div className="process-lifecycle__step-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="16" y="16" rx="1" width="6" height="6"></rect>
                    <rect x="2" y="16" rx="1" width="6" height="6"></rect>
                    <rect x="9" y="2" rx="1" width="6" height="6"></rect>
                    <path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3m-7-4V8"></path>
                  </g>
                </svg>
              </div>
              <div className="process-lifecycle__step-content">
                <h3 className="process-lifecycle__step-title">
                  Sharing &amp; Transfer
                </h3>
                <p className="process-lifecycle__step-text">
                  Cross-border transfer mechanisms, data processing agreements,
                  adequacy assessments, and controlled disclosure protocols.
                </p>
              </div>
            </div>
            <div className="process-lifecycle__arrow">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  d="M5 12h14m-6 6l6-6m-6-6l6 6"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </div>
            <div className="process-lifecycle__step">
              <div className="process-lifecycle__step-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <div className="process-lifecycle__step-content">
                <h3 className="process-lifecycle__step-title">
                  Retention &amp; Disposal
                </h3>
                <p className="process-lifecycle__step-text">
                  Automated retention policies, secure deletion procedures, data
                  archival strategies, and compliance with right to erasure.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="features-controls">
        <div className="features-controls__container">
          <div className="features-controls__header">
            <h2 className="features-controls__title section-title">
              Technical &amp; Organizational Controls
            </h2>
            <p className="section-content features-controls__description">
              Implement defense-in-depth privacy controls that protect data
              integrity, confidentiality, and availability across your entire
              technology ecosystem.
            </p>
          </div>
          <div className="features-controls__grid">
            <div className="features-controls__card">
              <div className="features-controls__card-visual">
                <div className="features-controls__icon">
                  <svg
                    width="48"
                    xmlns="http://www.w3.org/2000/svg"
                    height="48"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <rect
                        x="3"
                        y="11"
                        rx="2"
                        ry="2"
                        width="18"
                        height="11"
                      ></rect>
                      <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                    </g>
                  </svg>
                </div>
              </div>
              <div className="features-controls__card-content">
                <h3 className="features-controls__card-title">
                  Access Control &amp; Authentication
                </h3>
                <p className="features-controls__card-text">
                  Multi-factor authentication, least-privilege access,
                  role-based permissions, privileged access management, and
                  regular access reviews to ensure only authorized personnel
                  handle sensitive data.
                </p>
              </div>
            </div>
            <div className="features-controls__card">
              <div className="features-controls__card-visual">
                <div className="features-controls__icon">
                  <svg
                    width="48"
                    xmlns="http://www.w3.org/2000/svg"
                    height="48"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                      <path d="m9 12l2 2l4-4"></path>
                    </g>
                  </svg>
                </div>
              </div>
              <div className="features-controls__card-content">
                <h3 className="features-controls__card-title">
                  Encryption &amp; Pseudonymization
                </h3>
                <p className="features-controls__card-text">
                  End-to-end encryption standards, data masking techniques,
                  tokenization solutions, and cryptographic key management to
                  protect data confidentiality throughout its lifecycle.
                </p>
              </div>
            </div>
            <div className="features-controls__card">
              <div className="features-controls__card-visual">
                <div className="features-controls__icon">
                  <svg
                    width="48"
                    xmlns="http://www.w3.org/2000/svg"
                    height="48"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
              </div>
              <div className="features-controls__card-content">
                <h3 className="features-controls__card-title">
                  Audit Logging &amp; Monitoring
                </h3>
                <p className="features-controls__card-text">
                  Comprehensive activity logging, real-time monitoring
                  dashboards, anomaly detection, and tamper-proof audit trails
                  to maintain accountability and detect unauthorized data
                  access.
                </p>
              </div>
            </div>
            <div className="features-controls__card">
              <div className="features-controls__card-visual">
                <div className="features-controls__icon">
                  <svg
                    width="48"
                    xmlns="http://www.w3.org/2000/svg"
                    height="48"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <rect x="16" y="16" rx="1" width="6" height="6"></rect>
                      <rect x="2" y="16" rx="1" width="6" height="6"></rect>
                      <rect x="9" y="2" rx="1" width="6" height="6"></rect>
                      <path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3m-7-4V8"></path>
                    </g>
                  </svg>
                </div>
              </div>
              <div className="features-controls__card-content">
                <h3 className="features-controls__card-title">
                  Incident Response &amp; Breach Notification
                </h3>
                <p className="features-controls__card-text">
                  Privacy incident response playbooks, breach assessment
                  procedures, regulatory notification workflows, and
                  communication protocols to ensure timely and compliant
                  responses to data security events.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="timeline-standards">
        <div className="timeline-standards__container">
          <div className="timeline-standards__header">
            <h2 className="timeline-standards__title section-title">
              Regulatory &amp; Standards Alignment
            </h2>
            <p className="section-content timeline-standards__description">
              Demonstrate compliance with global privacy regulations and
              industry standards through mapped controls and continuous
              assessment.
            </p>
          </div>
          <div className="timeline-standards__wrapper">
            <div className="timeline-standards__line"></div>
            <div className="timeline-standards__item">
              <div className="timeline-standards__marker">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <div className="timeline-standards__content">
                <h3 className="timeline-standards__item-title">
                  ISO 27701 Privacy Information Management
                </h3>
                <p className="timeline-standards__item-text">
                  Implement ISO 27701 extension to ISO 27001 covering
                  privacy-specific requirements for PII controllers and
                  processors, including governance, risk management, and
                  operational controls.
                </p>
              </div>
            </div>
            <div className="timeline-standards__item">
              <div className="timeline-standards__marker">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <div className="timeline-standards__content">
                <h3 className="timeline-standards__item-title">
                  GDPR &amp; CCPA Compliance Frameworks
                </h3>
                <p className="timeline-standards__item-text">
                  Address requirements for lawful processing, data subject
                  rights, cross-border transfers, privacy by design, and
                  demonstrate accountability through documentation and technical
                  measures.
                </p>
              </div>
            </div>
            <div className="timeline-standards__item">
              <div className="timeline-standards__marker">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <div className="timeline-standards__content">
                <h3 className="timeline-standards__item-title">
                  SOC 2 Type II Privacy Criteria
                </h3>
                <p className="timeline-standards__item-text">
                  Design and evidence controls for SOC 2 privacy trust services
                  criteria covering collection, use, retention, disposal,
                  disclosure, and data quality management over a sustained
                  period.
                </p>
              </div>
            </div>
            <div className="timeline-standards__item">
              <div className="timeline-standards__marker">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <div className="timeline-standards__content">
                <h3 className="timeline-standards__item-title">
                  PCI-DSS Cardholder Data Protection
                </h3>
                <p className="timeline-standards__item-text">
                  Implement PCI-DSS requirements for cardholder data environment
                  protection including encryption, access control, network
                  segmentation, and vulnerability management specific to payment
                  data.
                </p>
              </div>
            </div>
            <div className="timeline-standards__item">
              <div className="timeline-standards__marker">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <div className="timeline-standards__content">
                <h3 className="timeline-standards__item-title">
                  AI Governance &amp; Algorithmic Transparency
                </h3>
                <p className="timeline-standards__item-text">
                  Address emerging AI GRC requirements for algorithmic fairness,
                  explainability, data minimization in model training, and
                  privacy-preserving machine learning techniques to ensure
                  responsible AI deployment.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="features-vendor">
        <div className="features-vendor__container">
          <div className="features-vendor__header">
            <h2 className="section-title features-vendor__title">
              Third-Party Privacy Risk Management
            </h2>
            <p className="section-content features-vendor__description">
              Maintain accountability across your vendor ecosystem through
              comprehensive third-party data protection assessments and ongoing
              monitoring.
            </p>
          </div>
          <div className="features-vendor__grid">
            <div className="features-vendor__card">
              <div className="features-vendor__card-header">
                <div className="features-vendor__icon">
                  <svg
                    width="40"
                    xmlns="http://www.w3.org/2000/svg"
                    height="40"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <h3 className="features-vendor__card-title">
                  Vendor Privacy Assessments
                </h3>
              </div>
              <p className="features-vendor__card-text">
                Conduct due diligence on third-party data handling practices
                including security posture, sub-processor arrangements, data
                residency, breach notification procedures, and contractual
                commitments before onboarding.
              </p>
            </div>
            <div className="features-vendor__card">
              <div className="features-vendor__card-header">
                <div className="features-vendor__icon">
                  <svg
                    width="40"
                    xmlns="http://www.w3.org/2000/svg"
                    height="40"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                        <path d="M6.376 18.91a6 6 0 0 1 11.249.003"></path>
                        <circle r="4" cx="12" cy="11"></circle>
                      </g>
                    </g>
                  </svg>
                </div>
                <h3 className="features-vendor__card-title">
                  Data Processing Agreements
                </h3>
              </div>
              <p className="features-vendor__card-text">
                Draft and negotiate comprehensive DPAs that define processing
                scope, controller-processor relationships, security obligations,
                audit rights, data subject rights support, and liability
                allocation in line with GDPR Article 28.
              </p>
            </div>
            <div className="features-vendor__card">
              <div className="features-vendor__card-header">
                <div className="features-vendor__icon">
                  <svg
                    width="40"
                    xmlns="http://www.w3.org/2000/svg"
                    height="40"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
                      <path d="m19 9l-5 5l-4-4l-3 3"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="features-vendor__card-title">
                  Continuous Vendor Monitoring
                </h3>
              </div>
              <p className="features-vendor__card-text">
                Establish ongoing oversight mechanisms including periodic
                reassessments, security questionnaire updates, breach
                notification tracking, and performance metrics to ensure
                sustained compliance throughout vendor relationships.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="cta-engagement">
        <div className="cta-engagement__wrapper">
          <div className="cta-engagement__content">
            <div className="cta-engagement__text">
              <h2 className="section-title cta-engagement__title">
                Ready to Build a World-Class Privacy Program?
              </h2>
              <p className="section-content cta-engagement__description">
                Partner with Cysigil to design privacy frameworks that protect
                your data, satisfy regulators, and build customer trust. Our
                experts will assess your current posture and deliver a roadmap
                for privacy excellence.
              </p>
              <div className="cta-engagement__actions">
                <a href="#contact">
                  <div className="btn-primary btn-xl btn">
                    <span>Schedule Privacy Consultation</span>
                  </div>
                </a>
              </div>
            </div>
            <div className="cta-engagement__visual">
              <img
                alt="A cybersecurity expert inspecting lines of code on multiple monitors in a dimly lit office."
                src="https://images.pexels.com/photos/6963098/pexels-photo-6963098.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                className="cta-engagement__image"
              />
            </div>
          </div>
        </div>
      </section>
      <div className="data-protection-privacy-container2">
        <div className="data-protection-privacy-container3">
          <Script
            html={`<script defer data-name="hero-video-fallback">
(function(){
  const heroVideo = document.querySelector(".hero-data-protection__video")

  if (heroVideo) {
    heroVideo.addEventListener("error", function () {
      const parent = heroVideo.parentElement
      parent.style.background = "linear-gradient(135deg, var(--color-primary), var(--color-secondary))"
      heroVideo.style.display = "none"
    })
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default DataProtectionPrivacy
